import { render, staticRenderFns } from "./vipcheckContent.vue?vue&type=template&id=4e540bfc&scoped=true"
import script from "./vipcheckContent.vue?vue&type=script&lang=js"
export * from "./vipcheckContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e540bfc",
  null
  
)

export default component.exports